import React from "react";
import PageLayout from "../components/PageLayout";
import { useTranslation } from "../i18n/LanguageContext";

function Artists() {
  const { t } = useTranslation();

  return (
    <PageLayout
      title={t("artists.title", "Artist Accounts")}
      subtitle={t("artists.subtitle", "Grow your fanbase and promote your music")}
    >
      <div className="space-y-8">
        <section>
          <h2 className="mb-4 text-2xl font-semibold text-blue-300">
            {t("artists.accountTitle", "🎤 What is an Artist Account?")}
          </h2>
          <p className="mb-4 text-slate-300">
            {t(
              "artists.accountText",
              "An Artist Account on PartyBuddy is your gateway to connect directly with fans, promote upcoming performances, and build your community."
            )}
          </p>
        </section>

        <section>
          <h2 className="mb-4 text-2xl font-semibold text-blue-300">
            {t("artists.featuresTitle", "What Can You Do?")}
          </h2>
          <ul className="space-y-3 text-slate-300">
            {[
              ["showcase", "Showcase Your Gigs:", "Promote your upcoming performances and reach new fans"],
              ["following", "Build Your Following:", "Connect with people who love your music"],
              ["community", "Engage Your Community:", "Share updates, behind-the-scenes content, and exclusive info"],
              ["tickets", "Sell Tickets:", "Integrated ticket sales for your events"],
              ["analytics", "Analytics:", "Track interest in your performances and grow your audience"],
            ].map(([key, fallbackLabel, fallbackText]) => (
              <li key={key} className="flex gap-3">
                <span className="text-blue-400">→</span>
                <span>
                  <strong>{t(`artists.features.${key}.label`, fallbackLabel)}</strong>{" "}
                  {t(`artists.features.${key}.text`, fallbackText)}
                </span>
              </li>
            ))}
          </ul>
        </section>

        <section>
          <h2 className="mb-4 text-2xl font-semibold text-blue-300">
            {t("artists.gettingStartedTitle", "Getting Started")}
          </h2>
          <p className="mb-4 text-slate-300">
            {t(
              "artists.gettingStartedText1",
              "Artist verification is coming soon. Once available, verified artists will unlock exclusive promotion tools and analytics."
            )}
          </p>
          <p className="text-slate-300">
            {t("artists.gettingStartedText2", "Interested in becoming an artist partner? Contact us at")}{" "}
            <a
              href="mailto:artists@partybuddy.app"
              className="text-blue-400 transition hover:text-blue-300"
            >
              artists@partybuddy.app
            </a>
          </p>
        </section>
      </div>
    </PageLayout>
  );
}

export default Artists;
